<template>
  <div class="element-input element-car-parts-list">
    <div class="label">{{ label }} ({{ partList.length }})</div>
    <ul>
      <li v-if="value.length > 0">
        <element-car-parts-select v-for="(parts, index) in partsList" :key="index"
        @deleteParts="deleteIndex" :option="parts" :index="index" :tag="'deleteParts'" :items="items" :partsdate="partsdate" :partedate="partedate" />
      </li>
      <li>
        <element-car-parts-select @addParts="parts" :index="-1" :tag="'addParts'" :items="items" :partsdate="partsdate" :partedate="partedate"/>
      </li>

    </ul>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "list", "partsdate", "partedate" ],
  data() {
    return {
      partsList: this.value,
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created(){
    this.$watch( "value", val => {
      this.partList = val;
    }, { immediate: true });
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    },
    parts( value ){
      this.partsList.push( value );
      this.$emit( "input", this.partsList );
    },
    deleteIndex( value ){
      this.partsList.splice(value, 1);
      this.$emit( "input", this.partsList );
    }
  }
}
</script>
